import { useState } from "react";
import classnames from "classnames";
import { IconButton } from "~/common/mui";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import { ImageWithFallback } from "../MediaLibraryItem/MediaLibraryItem";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

import classes from "./MediaPreview.module.less";

export const PdfPreview = ({ pages }: { pages: string[] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const isTablet = useIsMinTabletSize();

  if (pages.length === 0) {
    return null;
  }
  const previewCount = isTablet ? 2 : 1;
  const visiblePages = pages.slice(currentIndex, currentIndex + previewCount);
  const noOfPages = previewCount === 2 ? Math.ceil(pages.length / 2) : pages.length;
  const currentPage = previewCount === 2 ? currentIndex / 2 + 1 : currentIndex + 1;

  const renderImage = (src: string, i: number) => (
    <ImageWithFallback
      previewUrl={src}
      mediaType={`Preview page ${currentIndex + i + 1}`}
      className={classnames(previewCount === 2 ? classes.previewTwoImage : classes.previewImage)}
    />
  );

  const handlePrev = () => {
    if (previewCount === 1) {
      setCurrentIndex((prev) => prev - 1);
    } else {
      setCurrentIndex((prev) => Math.max(prev - previewCount, 0));
    }
  };

  const handleNext = () => {
    if (previewCount === 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setCurrentIndex((prev) => Math.min(prev + previewCount, pages.length - (pages.length % 2 === 0 ? 2 : 1)));
    }
  };

  return (
    <>
      {previewCount === 2 ? (
        <div className={classes.pagePreviewSection}>{visiblePages.map(renderImage)}</div>
      ) : (
        visiblePages.map(renderImage)
      )}

      {noOfPages > 1 && (
        <div className={classes.arrowBtnSection}>
          <div className={classes.iconArrowPrev}>
            <IconButton
              size="small"
              variant="contained"
              color="secondary"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                e.preventDefault();
                handlePrev();
              }}
              disabled={currentPage === 1}
            >
              <Icon type={IconType.ChevronLeft} />
            </IconButton>
          </div>
          {currentPage} / {noOfPages}
          <div className={classes.iconArrowNext}>
            <IconButton
              size="small"
              variant="contained"
              color="secondary"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                e.preventDefault();
                handleNext();
              }}
              disabled={currentPage === noOfPages}
            >
              <Icon type={IconType.ChevronRight} />
            </IconButton>
          </div>
        </div>
      )}
    </>
  );
};
